import axios from "axios";

const URL = process.env.REACT_APP_USER_API;

export async function getVendorCodes() {
  let url = URL + "/vendors";
  let response = await axios.get(url);
  console.log("getVendorCodes response", response)
  return response.data;
}

export async function addVendorCode(payload) {
  let url = URL + "/addvendor";
  let response = await axios.post(url, payload);
  return response.data;
}

export async function updateVendorCode(payload) {
  console.log("updateVendorCode payload")  
  let url = URL + "/updatevendor";
  const response = await axios.post(url, payload);
  console.log("updateVendorCode response",response)
  return response.data;
}
